<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <i-card-vertical headerTitle="비상 대응 매뉴얼 관리" device="web">
        <template v-slot:body>
          <DxDataGrid
            id="datagridRef"
            width="100%"
            class="layout-col-height00"
            :ref="dxDataGridRef"
            :data-source="datagrid"
            :show-borders="true"
            :show-row-lines="true"
            :column-auto-width="true"
            :allow-column-resizing="true"
            :allow-column-reordering="true"
            :focused-row-enabled="true"
            key-expr="id"
            @editor-preparing="onEditorPreparing"
          >
            <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />

            <DxScrolling row-rendering-mode="standard" />

            <DxSelection select-all-mode="allPages" show-check-boxes-mode="always" mode="multiple" />
            <DxColumn data-field="id" data-type="number" alignment="center" :visible="false" />
            <DxColumn
              data-field="clntId"
              data-type="string"
              alignment="left"
              caption="고객번호"
              :visible="false"
            />

            <DxColumn
              data-field="writeDt"
              data-type="string"
              alignment="left"
              caption="작성일"
              :visible="false"
            />
            <DxColumn
              data-field="docNo"
              data-type="string"
              alignment="left"
              caption="문서번호"
              :visible="false"
            />
            <DxColumn
              data-field
              data-type="string"
              width="120px"
              alignment="center"
              caption
              :allow-editing="false"
              cell-template="actionTemplete"
            ></DxColumn>
            <template #actionTemplete="{ data: cellInfo }">
              <v-btn
                color="primary"
                small
                elevation="0"
                @click="btnDetail(cellInfo)"
                class="grid-btn"
              >상세보기</v-btn>
            </template>

            <DxColumn
              data-field="type"
              width="100px"
              data-type="string"
              alignment="left"
              caption="등록 구분"
              :allow-editing="false"
            />
            <DxColumn
              data-field="manualNm"
              width="400px"
              data-type="string"
              alignment="left"
              caption="비상 대응 매뉴얼명"
              :allow-editing="false"
              css-class="devest-grid-header-require"
            />
            <DxColumn
              data-field="remark"
              width="400px"
              data-type="string"
              alignment="left"
              caption="비고"
              :allow-editing="false"
            />
          </DxDataGrid>
        </template>
        <template v-slot:drawer>
          <v-navigation-drawer
            v-model="procedureShow"
            width="75%"
            absolute
            right
            temporary
            class="feedback-area"
          >
            <ProcedureComponent :type="true" :subTitle="'절차서'" :pageTitle="'LeaderShip'" />
          </v-navigation-drawer>
        </template>
      </i-card-vertical>
      <v-sheet class="iCardRightWrap">
        <i-card-right
          :useBtnList="buttonUseList"
          @btnAdd="btnAdd()"
          @btnSearch="btnSearch(true)"
          @btnSave="btnSave()"
          @btnDelete="btnDelete()"
        ></i-card-right>
        <!-- <i-card-right>
          <template v-slot:customBtn>
            <i-icon-button
              color="btn_text"
              :text="'절차서'"
              :icon="'file'"
              @click="procedureShow = !procedureShow"
            ></i-icon-button>
          </template>
        </i-card-right>-->
      </v-sheet>
    </v-sheet>
  </v-container>
</template>

<script>
import baseview from '@/views/base/baseview.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'

import { getEmergencyResponseManual, deleteEmergencyResponseManual } from '@/api/emergencyActionPlan/emergencyResponseManual.js'
import ProcedureComponent from '@/views/procedure/components/ProcedureComponent.vue'

export default {
  mixins: [baseview, BaseDataGrid],
  components: {
    // 절차서 컴포넌트
    ProcedureComponent
  },
  data() {
    return {
      dxDataGridRef: 'datagridRef',
      datagrid: [],
      buttonUseList: [
        'btnSearch', //조회
        'btnDelete', //삭제
        'btnAdd' //추가
      ],
      //비동기문제로 test 키 걸어줌
      test: 0,
      selectedRow: {},
      initFiles: [],
      // 절차서 컴포넌트
      procedureContent: '',
      procedureShow: false // 절차서 보이기
    }
  },
  created() {
    // 초기 페이지 진입 시 compId 세팅
    this.initCompId = this.getCompId()
    this.btnSearch(true)
  },
  computed: {},
  beforeMount() {},
  mounted() {
    this.btnSearch(true)
  },
  activated() {
    if (this.$route.params?.search) {
      // 디테일 페이지에서 삭제, 추가 등 이벤트 발생 후 그리드 페이지 진입할 때
      this.btnSearch(true)
    }
    if (this.changedCompFlag(this.initCompId)) {
      // 로컬 스토리지에 저장된 값을 비교하여 변경 전 / 변경 후 compId가 다르고,
      // 페이지 진입시 세팅해두었던 compId 와 변경 후 compId와 다를 경우
      this.initCompId = this.getCompId()
      this.btnSearch(true)
    }
  },
  methods: {
    forceRerender() {
      this.componentKey += 1
    },
    btnAdd() {
      let data = {}
      Object.defineProperty(data, '__created__', {
        value: true,
        writable: true,
        enumerable: true,
        configurable: true
      })
      const toRouter = {
        name: 'EmergencyResponseManualDetail',
        params: {
          data: data
        }
      }
      this.$router.push(toRouter)
    },
    async btnDetail(cellInfo) {
      const toRouter = {
        name: 'EmergencyResponseManualDetail',
        params: {
          data: {
            clntId: cellInfo.data.clntId,
            writeDt: cellInfo.data.writeDt,
            docNo: cellInfo.data.docNo
          }
        }
      }
      this.$router.push(toRouter)
    },
    async btnSearch(isNotify) {
      this.openLoading('searching')
      let params = {
        clntId: this.getClntId()
      }
      await getEmergencyResponseManual(params, isNotify)
        .then(response => {
          if (response.success) {
            this.gridInit(this.GetDataGrid(this.dxDataGridRef))
            this.datagrid = response.list
          }
        })
        .finally(() => {
          this.endLoading()
        })
      this.test++
    },
    async btnDelete() {
      this.GetDataGrid(this.dxDataGridRef).beginUpdate()
      this.GetDataGrid(this.dxDataGridRef).saveEditData()

      var selectedRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()
      if (selectedRows.length === 0) {
        this.vToastify(this.$t('selectionData'), 'info')
        this.GetDataGrid(this.dxDataGridRef).endUpdate()
        return
      }

      if (selectedRows.filter(element => element.clntId === 'IGNS').length > 0 && this.getClntId() !== 'IGNS') {
        this.vToastify('(소중안) 매뉴얼은 삭제 하실 수 없습니다.', 'info')
        this.GetDataGrid(this.dxDataGridRef).endUpdate()
        return
      }

      this.vToastifyPrompt(
        this.$t('doDeleteData'),
        'info',
        current => {
          this.openLoading('deleting')

          deleteEmergencyResponseManual(selectedRows, true)
            .then(response => {
              if (response.success) {
                //
              }
            })
            .finally(() => {
              this.GetDataGrid(this.dxDataGridRef).endUpdate()
              this.endLoading()
              this.btnSearch(false)
            })
        },
        null,
        true
      )
    },
    deleteCallBack(selectedRows) {
      var index = null
      selectedRows.forEach(key => {
        index = this.datagrid.findIndex(obj => obj == key)
        this.datagrid.splice(index, 1)
      })
    },
    //////////////////////////////////////
    /*           DataGrid Event          */
    ///////////////////////////////////////
    //데이터 수정 시 로우 선택되도록
    onEditorPreparing(e) {
      if (e.parentType == 'dataRow') {
        var valueChanged = this.onCellValueChanged
        e.editorOptions.onValueChanged = args => {
          if (e.index > -1) {
            valueChanged(args.value, e)
          }
        }
      }
    },
    onCellValueChanged(value, cellInfo) {
      cellInfo.setValue(value)
      this.GetDataGrid(this.dxDataGridRef).selectRows(cellInfo.row.key, true)
    }
  }
}
</script>
<style></style>
